import axios from "axios";
import { Message } from "element-ui";

const errorCode = {
  401: "认证失败，无法访问系统资源",
  403: "当前操作没有权限",
  404: "访问资源不存在",
  default: "系统未知错误，请反馈给管理员",
};

//设置post请求的请求头
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";

//1. 创建axios对象
const service = axios.create({
  baseURL: "https://www.emboard.cn:9160",
  timeout: 5000,
});

//2. 请求拦截器
service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

//3. 响应拦截器
// service.interceptors.response.use(
//   (response) => {
//     //判断code码
//     return response.data;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );
// 响应拦截器

service.interceptors.response.use(
  (res) => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode["default"];
    // 二进制数据则直接返回
    if (
      res.request.responseType === "blob" ||
      res.request.responseType === "arraybuffer"
    ) {
      return res.data;
    }
    if (code === 500) {
      Message({ message: msg, type: "error" });
      return Promise.reject(new Error(msg));
    } else if (code === 601) {
      Message({ message: msg, type: "warning" });
      return Promise.reject("error");
    } else if (code !== 200) {
      Message.error({ message: msg });
      return Promise.reject("error");
    } else {
      return res.data;
    }
  },
  (error) => {

    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    this.$message({ message: message, type: "error", duration: 5 * 1000 });
    return Promise.reject(error);
  }
);
export default service;
